import { CompartmentOverview } from '../../models';

export class CompartmentOverviewLoad {
  public static readonly type = '[CompartmentOverview] Load Overview';
  constructor(public payload: { hubId: number; compartmentId: number }) {}
}

export class CompartmentOverviewInitialState {
  public static readonly type = '[CompartmentOverview] Set Initial State';
}

export class CompartmentOverviewUpdate {
  public static readonly type = '[CompartmentOverview] Update Compartment';
  constructor(
    public payload: {
      hubId: number;
      compartmentOverview: CompartmentOverview;
      listRefreshNeeded?: boolean;
    },
  ) {}
}

export class SetInitialErrorState {
  public static readonly type = '[CompartmentOverview] Set Initial Error State';
}
